import moment from "moment/moment";
import formatCurrency from "format-currency";
import createCustomerModal from "./modals/createCustomerModal/createCustomerModal.component";

class CustomersController {
  constructor($rootScope, $http, toastr, $state, AuthenticationService, $uibModal, $scope) {
    "ngInject";
    this.name = 'customers';
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.auth = AuthenticationService;
    this.toastr = toastr;
    this.$state = $state;
    this.customers = [];
    this.$uibModal = $uibModal;
    this.$scope = $scope;
    this.tableData = [];
    this.hasRevenueButNoContracts = false;

    this.customerFilter = {
      name: '',
      status: 'active',
    }

    this.filterrefresh = false;
    
    // Watch for table data changes to check for revenue without contracts
    $scope.$watch(() => this.tableData, (newData) => {
      if (newData && newData.length > 0) {
        this.hasRevenueButNoContracts = newData.some(customer => {
          const hasRevenue = customer.yearToDateRevenue && parseFloat(customer.yearToDateRevenue) > 0;
          const noContracts = !customer.contractCount || parseInt(customer.contractCount) === 0;
          return hasRevenue && noContracts;
        });
      } else {
        this.hasRevenueButNoContracts = false;
      }
    }, true);


    let self = this;

    this.customerColumns = [
      {
        displayName: 'Name',
        value: 'name',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          return "<a className=\"text-info\" href=\"admin/customers/"+record.id+"\" >"+record.name+"</a>";
        }
      },
      {
        displayName: 'Active Contracts',
        value: 'contractCount',
        sortable: false,
        sortValue: 'contractCount',
        dataType: 'text'
      },
      {
        displayName: 'All Time Revenue',
        value: 'allTimeRevenue',
        secure: this.auth.hasPermission('PERM_VIEW_CUSTOMER_REVENUE_INFORMATION'),
        sortable: true,
        dataType: 'text',
        formatting: function (record) {
          return '$'+formatCurrency(record.allTimeRevenue);
        }
      },      {
        displayName: 'Year To Date Revenue',
        value: 'yearToDateRevenue',
        sortable: true,
        secure: this.auth.hasPermission('PERM_VIEW_CUSTOMER_REVENUE_INFORMATION'),
        dataType: 'text',
        formatting: function (record) {
          return '$'+formatCurrency(record.yearToDateRevenue);
        }
      }
      // {
      //   displayName: 'Quickbooks',
      //   value: 'quickbooksId',
      //   dataType: 'text',
      //   secure: this.auth.hasPermission('PERM_ACCOUNTING_INTEGRATION'),
      //   sortable: true,
      //   formatting: function (record) {
      //     if(record.quickbooksId === null) {
      //       return '<span>Not Paired With QB</span>';
      //     } else if(record.operationInProgress === true) {
      //       return '<div class="v-middle" >\n' +
      //         '  <div class="spinner" style="margin: 0px;padding: 0px;height: 20px">\n' +
      //         '    <div class="rect1"></div>\n' +
      //         '    <div class="rect2"></div>\n' +
      //         '    <div class="rect3"></div>\n' +
      //         '    <div class="rect4"></div>\n' +
      //         '    <div class="rect5"></div>\n' +
      //         '  </div>\n' +
      //         '</div>';
      //     } else if(record.quickbooksId === null) {
      //       return '<i class=\"fa fa-refresh\"/>';
      //     } else {
      //       return '<i class=\"fa fa-check\"/>';
      //     }
      //   }
      // }
    ];

    this.filterCriteria = function () {
      return "status="+self.customerFilter.status+"&name="+self.customerFilter.name;
    }

    // Function to determine row class for highlighting
    this.getRowClass = (customer) => {
      const hasRevenue = customer.yearToDateRevenue && parseFloat(customer.yearToDateRevenue) > 0;
      const noContracts = !customer.contractCount || parseInt(customer.contractCount) === 0;
      if (hasRevenue && noContracts) {
        return 'warning-row';
      }
      return '';
    };

  }

 filterCustomers() {
    this.filterrefresh = true;
 }


  createCustomer() {
    let self = this;
    var modalInstance = this.$uibModal.open(createCustomerModal);

    modalInstance.success = function (customerData) {
      self.$http.post(self.$rootScope.apiHost+'/api/admin/customers', customerData, { withCredentials: true}).then(function (success) {
        modalInstance.dismiss();
        self.$state.go("admin.customer-details", {'customerId': success.data.id});
        self.toastr.success("Successfully Created Customer", "SUCCESS");
      });
    };

    modalInstance.cancel = function () {
      modalInstance.dismiss();
    };
  }

}


export default CustomersController;



// WEBPACK FOOTER //
// ./client/pages/admin/customers/customers.controller.js